export { default as Listar } from './Listar';
export { default as FormRegistro } from './FormRegistro';



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/index.js